import { render, staticRenderFns } from "./PromotionAcc.vue?vue&type=template&id=28aea448&scoped=true"
import script from "./PromotionAcc.vue?vue&type=script&lang=js"
export * from "./PromotionAcc.vue?vue&type=script&lang=js"
import style0 from "./PromotionAcc.vue?vue&type=style&index=0&id=28aea448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aea448",
  null
  
)

export default component.exports